import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { TransferAggregationSearchCrumbs } from 'subscription/constants/breadcrumb';
import ActionsList from './actions';
import PersonSearch from 'shell/components/shared/person-search';

const TransferAggregationSearch = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={TransferAggregationSearchCrumbs} />
      <PersonSearch
        pathname="/iscrizioni/aire-trasferimento-aggregazione/trasferimento"
        action={ActionsList}
        addedTitle="- Iscrizione AIRE per trasferimento - Aggregazione a famiglia"
        isAire
        isNationalSearch
      />
    </Fragment>
  );
};

TransferAggregationSearch.displayName = 'Transfer Aggregation Search page component';

export default TransferAggregationSearch;
